module.exports = __webpack_public_path__ + "static/img/icon_status1.0d63afa9.png";